<script>
    import { Router, Link, Route } from "svelte-routing";
    import ListRoute from "./list/index.html";
    import AddUpdate from "./addupdate/index.html";
    import AssignBatch from "./assignbatch/index.html";
    import Group from "./addUpdateGroup/index.html";
    import AddUpdateGroup from "./addUpdateGroup/addUpdate.html";
    import MODULES from "../utils/modules.js" 
    import Forbidden from "../forbidden.html"
    import ArchievedList from "./archievedList/index.html"
    
</script>

<Router>
    

    <Route path="info/:id/batch-info" let:params>
        <AssignBatch studentId="{params.id}"></AssignBatch>
    </Route>

    <Route path="info/:id/batch-info/edit/:assignedId" let:params>
        {#if MODULES.hasAccess(MODULES.UPDATE_ASSIGNED_BATCH)}
        <AssignBatch isEdit={true} studentId="{params.id}" _id={params.assignedId}></AssignBatch>
        {:else}
        <Forbidden />
        {/if}
    </Route>

    <Route path="groups">
        <Group></Group>
    </Route>
    <Route path="archived">
        <ArchievedList ></ArchievedList>
    </Route>

    <Route path="groups/:id" let:params>
        <AddUpdateGroup _id="{params.id}"></AddUpdateGroup>
    </Route>

    <Route path="info/:id/batch-info/:batchid" let:params>
        <AssignBatch studentId="{params.id}" batchid="{params.batchid}"></AssignBatch>
    </Route>
    <Route path="info/:id/batch-info/assignNew/:batchid" let:params>
        
        <AssignBatch studentId="{params.id}" newBatchid="{params.batchid}" newAssign={true}></AssignBatch>
    </Route>
    
    <Route path="">
        <ListRoute></ListRoute>
    </Route>
    <Route path="search/:searchQuery" let:params>
        <ListRoute searchQuery="{params.searchQuery}" ></ListRoute>
    </Route>
</Router>



